// App.tsx
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import { Suspense, useEffect } from 'react';
import AllRoutes from './routes/Routes';
import { ThemeColorProvider } from './components/Theme/ThemeColorContext';
import SuspenseFallback from './SuspenseFallback';
import TechAlertsBanner from './features/autonomous/components/TechAlertsBanner';
import AssistantLauncher from './features/autonomous/components/AssistantLauncher';

const FirstPaintNotifier = () => {
  useEffect(() => {
    (window as any).__hideStaticPreloader?.();
  }, []);
  return null;
};

const App = () => {
  return (
    <BrowserRouter>
      <ThemeColorProvider>
        <Suspense fallback={<SuspenseFallback />}>
          <AllRoutes />
          <TechAlertsBanner />
          <AssistantLauncher />
          <FirstPaintNotifier />
        </Suspense>
      </ThemeColorProvider>
    </BrowserRouter>
  );
};

export default App;